import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { SectionHeading } from '../ui';

/** VE section kept from the current home: the conditions families ask about most. */
const CONDITIONS = [
  { to: '/back-pain/', label: 'Back Pain' },
  { to: '/colic/', label: 'Colic & Fussy Babies' },
  { to: '/ear-infections/', label: 'Ear Infections' },
  { to: '/prenatal-chiropractic/', label: 'Pregnancy Care' },
  { to: '/headaches-and-migraines/', label: 'Headaches & Migraines' },
  { to: '/add-adhd/', label: 'ADHD & Focus' },
  { to: '/anxiety/', label: 'Anxiety & Stress' },
  { to: '/sciatica/', label: 'Sciatica' },
];

export default function ConditionsTeaser() {
  return (
    <section className="ve-section ve-section--surface ve-home-conditions" aria-labelledby="home-conditions-title">
      <div className="ve-container">
        <SectionHeading
          eyebrow="Conditions"
          title="Conditions We Help Every Day"
          id="home-conditions-title"
          align="center"
          intro="Families come to us for far more than back pain. These are the concerns we see most often in our Royal Oak office, and each one links to what care looks like for it."
        />
        <ul className="ve-related ve-home-condition-links">
          {CONDITIONS.map((c) => (
            <li key={c.to}>
              <Link to={c.to}>
                <span>{c.label}</span>
                <ArrowRight aria-hidden="true" focusable="false" />
              </Link>
            </li>
          ))}
        </ul>
        <p className="ve-center ve-home-conditions-more">
          Not seeing yours? Browse everything on our <Link to="/we-can-help/">We Can Help</Link> page.
        </p>
      </div>
    </section>
  );
}
